import { ComponentErrorBoundary } from '@app/utilities';

//TODO: seems duplicated, might be removed when choosing a congruent styling solution
type Width =
  | 'one'
  | 'two'
  | 'three'
  | 'four'
  | 'five'
  | 'six'
  | 'seven'
  | 'eight'
  | 'nine'
  | 'ten'
  | 'eleven'
  | 'twelve'
  | 'thirteen'
  | 'fourteen'
  | 'fifteen'
  | 'sixteen';

export function MasterDetailLayout({
  master,
  detail,
  masterWidth = 'five',
  detailWidth = 'eleven',
  height = 'calc(100vh - 225px)',
}: {
  master: JSX.Element;
  detail: JSX.Element;
  masterWidth?: Width;
  detailWidth?: Width;
  height?: string;
}) {
  return (
    <ComponentErrorBoundary>
      <div className={'ui grid divided stackable'} style={{ height: height }}>
        <div className={`${masterWidth} wide column`} style={{ height: height }}>
          {master}
        </div>
        <div className={`${detailWidth} wide column`} style={{ height: height, overflow: 'auto' }}>
          {detail}
        </div>
      </div>
    </ComponentErrorBoundary>
  );
}
